import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

import { getSoftwarePortfolios } from '../../../services/portfolio.service';

// import { formatDate } from '../../../utils/utils';
import SoftwarePortfolioItem from './softwarePortfolioItem';

// const apiUrl = process.env.REACT_APP_API_URL;

function SoftwarePortfolios() {

    const [softwarePortfolios, setSoftwarePortfolios] = useState();

    useEffect(() => {
        const fetchSoftwarePortfolios = () => {
            getSoftwarePortfolios().then((res) => {
                setSoftwarePortfolios(res.data);
            }).catch((err) => {
                console.log(Error);
            });
        }

        fetchSoftwarePortfolios();

    }, [])

    return (
        <div className="w-full min-h-screen bg-white dark:bg-dark-bg transition-colors duration-300">
            <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">

                <div className="flex flex-col text-primary dark:text-white mb-12 items-center gap-4 pt-12">
                    <motion.p 
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        className='text-4xl font-bold text-center'
                    >
                        What We’ve Built
                    </motion.p>
                    <motion.p 
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1 }}
                        className='text-primary/70 dark:text-gray-400 text-center w-full lg:w-2/3 text-lg'
                    >
                        Our portfolio reflects our commitment to excellence, innovation, and problem-solving. Take a look at some of the projects that have empowered businesses to reach new heights.
                    </motion.p>
                </div>

                <motion.div 
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    className="grid grid-cols-1 md:grid-cols-2 gap-8"
                >
                    {softwarePortfolios && softwarePortfolios.map((portfolio) => {
                        return (
                            <SoftwarePortfolioItem key={portfolio.id} portfolio={portfolio}/>
                        );
                    })}
                </motion.div>
            </div>
        </div>
    );
}

export default SoftwarePortfolios;